import { htmlSafe } from '@ember/template';
import { t } from 'i18n';
export function subunitsLabel(subunits, totalSubunitsCount, {
  enabledAtAllUnits = false,
  enabledAtFutureUnits = false,
  useAsFilter = false
} = {}) {
  // Copied from Ember enumerable's .compact()
  const subunitList = subunits.filter(value => value != null); // eslint-disable-line eqeqeq

  return htmlSafe(labelForSubunitList(subunitList, totalSubunitsCount, enabledAtAllUnits, enabledAtFutureUnits, useAsFilter));
}
function labelForSubunitList(subunits, totalSubunitsCount, enabledAtAllUnits, enabledAtFutureUnits, useAsFilter) {
  if (enabledAtFutureUnits) {
    return t('subunit.subunitList.future');
  }
  if (enabledAtAllUnits) {
    return t('subunit.subunitList.all');
  }
  switch (subunits.length) {
    case 0:
      return useAsFilter ? t('subunit.subunitList.all') : t('subunit.subunitList.none');
    case 1:
      return t('subunit.subunitList.one', {
        nickname1: subunits[0]
      });
    case totalSubunitsCount:
      return t('subunit.subunitList.all');
    default:
      return t('subunit.subunitList.more', {
        count: subunits.length
      });
  }
}

/**
 * Sort units first by active status, then by name (case insensitive).
 * @param   {MerchantSubunit} a   First unit object to compare.
 * @param   {MerchantSubunit} b   Second unit object to compare.
 * @returns {number}  Value indicating order of elements.
 */
export function sortUnits(a, b) {
  if (typeof a.nickname === 'undefined') {
    return -1;
  } else if (typeof b.nickname === 'undefined') {
    return 1;
  }

  // Sort by active status, then by name
  if (a.unitActive === b.unitActive) {
    return a.nickname.toLowerCase() < b.nickname.toLowerCase() ? -1 : 1;
  } else if (a.unitActive) {
    return -1;
  } else {
    return 1;
  }
}